<template>
  <BaseModal
    :heading="$t('global.message')"
    small
    @close="$emit('close')"
    useForm
    @submit="submit"
  >
    <Flex direction="column">
      <BaseInput
        v-model="email"
        type="email"
        :label="$t('global.email')"
        required
        v-test="'sendToSupplierEmail'"
      />
      <BaseEditor
        v-model="message"
        :label="$t('global.message')"
        v-test="'sendToSupplierMessage'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('close')"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="isLoading"
        submitForm
        v-test="'sendToSupplierSave'"
      >
        {{ $t('global.actions.send') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import { flash } from '@/helpers/ui';

export default defineComponent({
  props: {
    supplierEmail: {
      type: String,
      required: false,
    },
  },
  emits: ['submit', 'close'],
  data() {
    return {
      email: '',
      message: '',
      feedbackId: null,
      isLoading: false,
    };
  },
  methods: {
    callback() {
      this.isLoading = false;
      this.$emit('submit');
      this.$emit('close');
      flash(this.$t('global.flash.message_sent'));
    },
    submit() {
      this.isLoading = true;

      const input = {
        destination: this.email,
        message: this.message,
        gateway: 'EMAIL',
        messageType: 'STOCK_ORDER',
        stockOrderId: Number.parseInt(this.$route.params.stockOrderId),
      };

      this.$apollo
        .mutate({
          mutation: gql`
            mutation createMessage($input: CreateMessageInput!) {
              createMessage(input: $input) {
                errors
              }
            }
          `,
          variables: {
            input,
          },
        })
        .then(() => {
          this.callback();
        });
    },
  },
  created() {
    if (this.supplierEmail) {
      this.email = this.supplierEmail;
    }
  },
});
</script>
